'use client'
import { EthereumWalletConnectors } from './EthereumWalletConnectors.js';

const EthereumWalletConnectorsWithConfig = (providersConfig) => {
    const classWithConfig = (className) => class extends className {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        constructor(...args) {
            const [opts] = args;
            // TODO: remove this once we remove the deprecated `publicClientHttpTransportConfig`
            const updatedProviderConfig = {
                httpTransportConfig: Object.assign(Object.assign({}, providersConfig.httpTransportConfig), providersConfig.publicClientHttpTransportConfig),
            };
            super(Object.assign(Object.assign({}, opts), { providersConfig: updatedProviderConfig }));
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props) => EthereumWalletConnectors(props).map(classWithConfig);
};

export { EthereumWalletConnectorsWithConfig };
